import TagAPI from '@/services/api/tag'

const index = {
	namespaced: true,
	state: () => ({
		tagList: [],
		searchTagList: [],
	}),
	getters: {},
	mutations: {
		setTags: (state, payload) => {
			state.tagList = payload
		},
		setSearchTags: (state, payload) => {
			state.searchTagList = payload
		},
	},
	actions: {
		loadTags: async ({ commit }, payload) => {
			const instId = payload
			const response = await TagAPI.lookupTags(instId)
			commit('setTags', response.data)
		},
		loadSearchTags: async ({ commit }, payload) => {
			const instId = payload
			const response = await TagAPI.lookupSearchTags(instId)
			commit('setSearchTags', response.data)
		},
		deleteTag: async ({ rootGetters }, ids) => {
			await TagAPI.deleteTag(rootGetters.instituteId, { ids })
		},
	},
}
export default index
